// extracted by mini-css-extract-plugin
module.exports = {"product-section":"dfK8OOPSCpoGwgfaD89rp","preLoaderShimmer":"J19ofpsWhHhkTuMMZsL3R"};